<div class="n-list-component-header">
  <h2>List of events</h2>
  <div>
    <!-- <button matIconButton matTooltip="Here comes the info"><mat-icon>info</mat-icon></button> -->
    <button matIconButton matTooltip="Select columns"
      (click)="openColumnSelector()"><mat-icon>view_column</mat-icon></button>
  </div>
</div>

<form [formGroup]="filterForm" class="n-filters-form">
  <div>
    <mat-expansion-panel [(expanded)]="filtersExpanded" #filtersPanel style="margin: 5px 0px; flex-grow: 1; ">
      <mat-expansion-panel-header>
        <mat-panel-title><mat-icon>search</mat-icon> Filters </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="n-filter-form-row" style="align-items: flex-start">
        <div class="n-select-filter-field-column">
          <mat-form-field class="n-search-field n-filter-flex-unit" style="width: 100%">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput placeholder="Name filter" #simpleFilterInput formControlName="textFilter">
          </mat-form-field>
          <app-advanced-select #responsiblePersonsSelect formControlName="responsiblePersons"
            [resetTrigger]="resetCounter" class="n-search-field n-filter-flex-unit" label="Responsible person"
            [options]="allResponsiblePersonOptions()" [showAllOrAny]="showAllOrAny()" />
        </div>
        <div class="n-select-filter-field-column">
          <mat-form-field class="n-search-field n-filter-flex-unit" style="width: 100%">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [formGroup]="activeRange" [rangePicker]="activeRangePicker">
              <input matStartDate formControlName="start" placeholder="Start date">
              <input matEndDate formControlName="end" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="activeRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #activeRangePicker></mat-date-range-picker>
            @if (activeRange.controls['start'].hasError('matStartDateInvalid')) {
            <mat-error>Invalid start date</mat-error>
            }
            @if (activeRange.controls['end'].hasError('matEndDateInvalid')) {
            <mat-error>Invalid end date</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="n-select-filter-field-column">
          <app-advanced-select #eventTypesSelect formControlName="eventTypes" [resetTrigger]="resetCounter"
            class="n-search-field n-filter-flex-unit" label="Event types" [options]="allEventTypeOptions()"
            [showAllOrAny]="showAllOrAny()" />
        </div>
        <div class="n-select-filter-field-column">
          <app-advanced-select #topicsSelect formControlName="topics" [resetTrigger]="resetCounter"
            class="n-search-field n-filter-flex-unit" label="Topics of interest" [options]="allTopicOptions()"
            [showAllOrAny]="showAllOrAny()" />
        </div>
        <button matFab (click)="clearAllFilters()" class="n-filter-reset-button"
          matTooltip="Clear all filters"><mat-icon>clear</mat-icon></button>
      </div>
    </mat-expansion-panel>
  </div>
</form>

<div class="n-table-wrapper">
  @if (loading) {
  <div class="n-spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
  }

  <div class="n-table-scroll">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <ng-container matColumnDef="valid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Is data valid?"><mat-icon>check</mat-icon>
        </th>
        <td mat-cell *matCellDef="let event">
            @if (event.validityStatus() === ValidityStatus.INVALID) {
            <span class="material-symbols-outlined n-invalid-status"
              matTooltip="Record is missing required data">error</span>
            } @else if (event.validityStatus() === ValidityStatus.INCOMPLETE) {
            <span class="material-symbols-outlined n-incomplete-status"
              matTooltip="Record is missing important data">warning</span>
            } @else if (event.validityStatus() === ValidityStatus.VALID) {
            <span class="material-symbols-outlined n-valid-status" matTooltip="Record is valid">verified</span>
            } @else {
            <span class="material-symbols-outlined">cruelty_free</span>
            }
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let event"><span class="n-ellipsis" matTooltip="{{ event.name }}"> {{ event.name
            }}</span></td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="responsiblePerson">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsible person</th>
        <td mat-cell *matCellDef="let event">{{ event.responsiblePerson }}</td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let event">{{ event.date | date: 'dd/MM/yyyy'}}</td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>End date</th>
        <td mat-cell *matCellDef="let event">{{ event.endDate | date: 'dd/MM/yyyy'}}</td>
      </ng-container>

      <!-- Attendance Type Column -->
      <ng-container matColumnDef="attendanceType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Attendance type</th>
        <td mat-cell *matCellDef="let event">{{ event.attendanceType }}</td>
      </ng-container>

      <!-- Topics of interest Column -->
      <ng-container matColumnDef="topics">
        <th mat-header-cell *matHeaderCellDef>Topics of interest</th>
        <td mat-cell *matCellDef="let event">
          <mat-chip-set class="n-my-chip">
            @for (topic of event.topics; track topic.id) {
            <mat-chip><span matTooltip="{{topic.name}}">{{ topic.name }}</span></mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Event Types Column -->
      <ng-container matColumnDef="eventTypes">
        <th mat-header-cell *matHeaderCellDef>Event types</th>
        <td mat-cell *matCellDef="let event">
          <mat-chip-set class="n-my-chip">
            @for (t of event.eventTypes; track t.id) {
            <mat-chip><span matTooltip="{{t.name}}">{{ t.name }}</span></mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Projects Column -->
      <ng-container matColumnDef="projects">
        <th mat-header-cell *matHeaderCellDef>Projects</th>
        <td mat-cell *matCellDef="let event">
          <mat-chip-set class="n-my-chip">
            @for (project of event.projects; track project.id) {
            <mat-chip><span matTooltip="{{project.fullName}}">{{ project.name }}</span></mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- lastModifiedOn Column -->
      <ng-container matColumnDef="lastModifiedOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last modification</th>
        <td mat-cell *matCellDef="let event">
          {{ event.lastModifiedOn | date:'dd/MM/yyyy HH:mm' }}
        </td>
      </ng-container>

      <tr mat-header-row class="n-grid-header-row" *matHeaderRowDef="selectedColumns"
        [ngStyle]="{ 'grid-template-columns': gridTemplate }">
      </tr>
      <tr mat-row class="n-grid-data-row" *matRowDef="let row; columns: selectedColumns"
        [ngStyle]="{ 'grid-template-columns': gridTemplate }" (click)="goToDetail(row)">
      </tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter</td>
      </tr>


    </table>
  </div>
</div>
<mat-paginator #paginator class="demo-paginator" showFirstLastButtons="true" hidePageSize="false"
  [pageSizeOptions]="[5,10,25]" aria-label="Select page">
</mat-paginator>

<div class="n-button-row">
  <button matFab extended class="n-save-button" (click)="add()"><mat-icon>add</mat-icon> Add event</button>
  <!-- <button matFab extended class="n-export-button" (click)="export()"><mat-icon>file_download</mat-icon>Export
    list</button> -->
</div>